import React, { Dispatch } from 'react';

import { ProjectType } from '../../../../types';

export type NavigationButtonsStatus = {
  back: boolean;
  next: boolean;
};

export enum FlowActions {
  setLoading = 'setLoading',
  loadProject = 'loadProject',
  setApplyButton = 'setApplyButton',
}

export type FlowAction =
  | { type: FlowActions.loadProject; project: ProjectType | null }
  | { type: FlowActions.setLoading; loading: boolean }
  | { type: FlowActions.setApplyButton; button: any };

export type ProjectFlowStateType = {
  project: ProjectType | null;
  loading: boolean;
  applyButton: any;
};

type Action = FlowAction;

const initialState: ProjectFlowStateType = {
  project: null,
  loading: true,
  applyButton: null,
};

function reducerImplementation(state: ProjectFlowStateType, action: Action) {
  switch (action.type) {
    case FlowActions.setLoading:
      return {
        ...state,
        loading: action.loading,
      };
    case FlowActions.loadProject:
      return {
        ...state,
        project: action.project,
      };
    case FlowActions.setApplyButton:
      return {
        ...state,
        applyButton: action.button,
      };
    default:
      throw new Error();
  }
}

export function reducer(state: ProjectFlowStateType, action: Action): ProjectFlowStateType {
  return reducerImplementation(state, action);
}

export function useProjectFlowReducer(): [ProjectFlowStateType, Dispatch<any>] {
  return React.useReducer(reducer, initialState);
}
